import { Button, Text } from '@mantine/core';
import { IconRobot } from '@tabler/icons-react';
import PropTypes from 'prop-types';
import { coral } from 'theme/colors';
import { radius } from 'theme/radius';
import { shadows } from 'theme/shadows';

const AskAIButton = ({ onOpenDialog }) => (
  <Button
    leftSection={<IconRobot size={20} color="white" />}
    size="lg"
    onClick={onOpenDialog}
    style={{
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 8,
      paddingBottom: 8,
      borderRadius: radius.pill,
      backgroundColor: coral[6],
      color: 'white',
      boxShadow: shadows.card,
      textTransform: 'none'
    }}
    styles={{
      root: {
        '&:hover': {
          backgroundColor: coral[7],
          boxShadow: shadows.cardHover
        }
      }
    }}
  >
    <Text fw={600} size="md" c="white">
      Ask AI
    </Text>
  </Button>
);

AskAIButton.propTypes = {
  onOpenDialog: PropTypes.func.isRequired
};

export default AskAIButton;
